export default "__VITE_ASSET__CnZPENm3__"